import UserApi from '../Api/UserApi.js';
import CartApi from '../Api/CartApi.js';
import intToReal from '@helpers/intToReal';
import gtmDataLayer from '@helpers/gtmDataLayer';
import setCookie from '@helpers/setCookie';
import VueTinySlider from 'vue-tiny-slider';
import getFeaturedProducts from '@services/inventory/getFeaturedProducts';

new Vue({
  el: '[data-vue=header]',
  components: {
    'tiny-slider': VueTinySlider,
    'mini-cart': () => import('../MiniCart/MiniCart.vue'),
    'discount-indicator': () => import('../MiniCart/DiscountIndicator.vue'),
    'notification-inbox': () => import('../NotificationInbox/NotificationInbox.vue'),
    'card-bolao-featured': () => import('@components/BoxBoloes/CardBolaoFeatured.vue'),
    'count-down': () => import('@components/RegressiveCounter/CountDown.vue'),
    'skeleton-bolao-home': () => import('@components/Skeleton/AnimatedPlaceHolder.vue')
  },
  data: {
    today: new Date(),
    endPromotionDate: new Date('November 26, 2023 23:59:59'),
    endPromotion: true,
    featuredPromotion: false,
    boloes: null,
    showMenu: false,
    showUserMenu: false,
    showMinicart: false,
    userInfo: null,
    loaded: false,
    minicart: null,
    minicartLoaded: false,
    totalNumberOfItems: 0,
    notificationInboxActive: false,
    notificationCount: 0,
    xtremepushAttemptCount: 0,
    xtremepushIsLoaded: false,
    tinySliderOptionsBolao: {
      items: 1,
      center: false,
      autoplay: false,
      edgePadding: 10,
      autoplayButtonOutput: true,
      gutter: 20,
      loop: false,
      nav: true,
      slideBy: 'page',
      controlsText: ['', ''],
      responsive: {
        768: {
          items: 2
        },
        1085: {
          items: 2
        },
        1260: {
          items: 3
        },
        1410: {
          items: 4
        }
      }
    }
  },
  methods: {
    getPosition () {
      const viewportHeight = window.innerHeight;
      const menuFloat = document.querySelector('.menu-header-fixed')
      const positionSubMenu = document.querySelector('.page-nav')
      const shadowMenu = document.querySelector('.main-header__shadow-floats')
      const contentSite = document.querySelector('.main-content')
      const mgFriday = document?.querySelector('.destaques-home')?.offsetHeight;

      if (mgFriday) {
        document.addEventListener('scroll', (event) => {
          if (window.scrollY >= mgFriday) {
            menuFloat.classList.add('active')
            contentSite.classList.add('active-black-friday')
          }
          if (window.scrollY <= mgFriday) {
            menuFloat.classList.remove('active')
            contentSite.classList.remove('active-black-friday')
          }
          if (window.scrollY > viewportHeight) {
            menuFloat.classList.add('active')
            contentSite.classList.add('active-black-friday')
          }
        })
      }
      if ((!document.querySelector('[data-app="home"]')) && this.endPromotion) {
        menuFloat.classList.add('active')
        contentSite.classList.add('active-black-friday')
      }
      if ((!document.querySelector('[data-app="home"]')) && !this.endPromotion) {
        menuFloat.classList.add('active')
        contentSite.classList.add('active')
        positionSubMenu?.classList.add('active-top')
        shadowMenu.classList.add('active-top')
      }
      if ((document.querySelector('[data-app="home"]')) && !mgFriday) {
        menuFloat.classList.add('active')
        contentSite.classList.add('active')
        shadowMenu.classList.add('active-top')
      }
    },
    fetch () {
      getFeaturedProducts({
        qty: 9,
        completeQty: false
      }).then((res) => {
        this.boloes = res || [];
      })
        .catch((err) => {
          console.error(err);
        })
        .then(() => {
          this.loaded = true;
        });
    },
    intToReal: intToReal,
    openNotificationInbox: function () {
      this.notificationInboxActive = true;
    },
    initNotification () {
      if (window.xtremepush === undefined && this.xtremepushAttemptCount < 4) {
        this.xtremepushAttemptLoadRef = setTimeout(() => {
          this.xtremepushAttemptCount++
          this.initNotification();
        }, 1000);

        return;
      }

      if (this.xtremepushAttemptCount === 4) {
        console.error('Xtremepush not loaded');
        return;
      }

      xtremepush('ready', () => {
        this.loadNotification();
        setInterval(() => {
          this.loadNotification();
        }, 20000);
      });
    },
    loadLastMessageAndOpen () {
      xtremepush('inbox', 'message.list', {
        limit: 1,
        offset: 0
      }, (data) => {
        if (data.items[0] && data.items[0].message.open === 'true') {
          this.openNotificationInbox();
        }
      }, (error) => {
        this.loading = false;
        console.error('loadMessages', error);
      });
    },
    loadNotification: function () {
      xtremepush('inbox', 'badge', {}, (result) => {
        if (this.xtremepushIsLoaded && result.badge > this.notificationCount) {
          this.loadLastMessageAndOpen();
        }
        this.notificationCount = result.badge;
        this.xtremepushIsLoaded = true;
      }, (err) => {
        console.error(err);
      });
    },
    updateBadge: function (number) {
      this.notificationCount = number;
    },
    toggleMenu: function () {
      const altura = document?.querySelector('.destaques-home')?.offsetHeight;
      const largura = window.innerWidth
      if (largura <= 992) {
        if (window.scrollY < altura) {
          window.scrollTo({
            top: altura,
            behavior: 'smooth'
          })
        }
      }
      if (this.showUserMenu) {
        this.toggleUserMenu();
      }
      if (this.showMinicart) {
        this.toggleMinicart();
      }

      this.showMenu = !this.showMenu;
      const body = document.querySelector('body');
      body.classList.toggle('is-menu-active');
    },
    toggleUserMenu: function (event) {
      const altura = document?.querySelector('.destaques-home')?.offsetHeight;
      const largura = window.innerWidth
      if (largura <= 992) {
        if (window.scrollY < altura) {
          window.scrollTo({
            top: altura,
            behavior: 'smooth'
          })
        }
      }
      if (event) {
        event.preventDefault();
      }
      if (this.showMenu) {
        this.toggleMenu();
      }
      if (this.showMinicart) {
        this.toggleMinicart();
      }

      const body = document.querySelector('body');
      body.classList.toggle('is-user-menu-active');

      this.showUserMenu = !this.showUserMenu;
    },
    toggleMinicart: function (event) {
      if (event) {
        event.preventDefault();
      }
      this.showMinicart = !this.showMinicart;

      if (this.showMenu) {
        this.toggleMenu();
      }
      if (this.showUserMenu) {
        this.toggleUserMenu();
      }

      if (this.showMinicart) {
        Vue.$toast.clear();
      }

      const body = document.querySelector('body');
      body.classList.toggle('is-user-minicart-active');
    },
    getTotalNumberOfItems () {
      let amount = 0;

      if (!this.minicart) {
        return;
      }

      this.minicart.items.forEach((item) => {
        amount += item.unitsAcquired;
      });

      return amount;
    },
    removeFloats: function () {
      this.showMenu = false;
      this.showUserMenu = false;
      this.showMinicart = false;
      const body = document.querySelector('body');
      body.classList.remove('is-user-menu-active');
      body.classList.remove('is-menu-active');
      body.classList.remove('is-user-minicart-active');
    },
    fetchInfo: function (force = false) {
      const _self = this;

      UserApi.get(force)
        .then(async (res) => {
          _self.userInfo = res;
          if (window.location.pathname.includes('minha-conta')) {
            return;
          }

          if (res && (!res.termsOfUse && !sessionStorage.getItem(`termsOfUse_${res.userID}`))) {
            const termsConditionsRes = await window.Modal.open('TERMS_CONDITIONS', null);
            if (termsConditionsRes && termsConditionsRes.action === 'accept') {
              sessionStorage.setItem(`termsOfUse_${res.userID}`, true);
              this.fetchInfo(true);
            }

            if (!window.location.pathname.includes('minha-conta')) {
              window.location.href = '/minha-conta';
            }
          }
        })
        .catch((err) => console.error(err))
        .then(() => {
          _self.loaded = true;
        });

      CartApi.getItems()
        .then((res) => {
          if (res) {
            _self.minicart = res;
            _self.totalNumberOfItems = this.getTotalNumberOfItems();
          }
        })
        .catch(() => {})
        .then(() => {
          _self.minicartLoaded = true;
        });
    },
    removeItemCart: function (id) {
      const confirm = window.confirm('Tem certeza que deseja remover este item?');
      if (!confirm) {
        return;
      }

      const _self = this;
      _self.minicartLoaded = false;

      const trackingInfo = _self.minicart.items;

      CartApi.delete(id, true, trackingInfo)
        .then(() => {
          Vue.$toast.open({
            message: 'Item removido sucesso!'
          });
        })
        .catch(() => {
          Vue.$toast.open({
            type: 'error',
            message: 'Erro ao tentar remover o item.'
          });
        })
        .then(() => {
          _self.minicartLoaded = true;
        });
    },
    userLogout () {
      const dataUser = {
        userID: this.userInfo.userID || 0
      };

      gtmDataLayer(dataUser, 'logout')

      window.location.href = '/logout';
    }
  },
  created: function () {
    if (document.querySelector('[data-app="home"]')) {
      this.featuredPromotion = true;
    }
    if (this.today > this.endPromotionDate) {
      this.endPromotion = false
    }
    this.fetchInfo();

    const _self = this;

    window.addEventListener('user:reload', function (e) {
      _self.userInfo = e.detail || null;
    });

    window.addEventListener('cart:update', function (e) {
      _self.minicart = e.detail || null;
      _self.totalNumberOfItems = _self.getTotalNumberOfItems();
    });
  },
  mounted: function () {
    const $mainMenuBlocks = document.querySelectorAll('.main-sidebar__menu');

    $mainMenuBlocks.forEach(($menuBlock) => {
      const $titleEl = $menuBlock.querySelector('.main-sidebar__menu__title');
      $titleEl.onclick = function () {
        $menuBlock.classList.toggle('active');
      };
    });

    window.onbeforeunload = function (e) {
      setCookie('paymentMethodId', '', -1);
    };

    this.initNotification();
    this.fetch();
    this.getPosition();

    document.querySelectorAll('[data-cfsrc]').forEach((el) => {
      el.style.visibility = null;
      el.style.display = null;
      el.setAttribute('src', el.getAttribute('data-cfsrc'));
    });
  }
});
